import * as React from 'react';
import { IconSubscriptions } from '../../icons';
import { BackofficeRoute } from '../../types/route.interfaces';
import SubscriptionsPage from './pages/Subscriptions';

const subscriptionRoutes: BackofficeRoute[] = [
  {
    sidebar: {
      icon: IconSubscriptions,
      translationKey: 'menu.subscriptions',
    },
    path: '/subscriptions',
    element: <SubscriptionsPage />,
  },
];

export default subscriptionRoutes;
